<template lang="pug">
.side-menu(:data-role='userRole')
  .side-menu__head
    .side-menu__head__logo
      image-base(:src='require("@/assets/img/common/logo.svg")')
    .side-menu__head__role
      .side-menu__head__role__organization(v-if='organizationName') {{ organizationName }}
      .side-menu__head__role__user {{ userName }} {{ sideMenuSetting.userNameSuffix }}
  .side-menu__links
    template(v-for='linkSetting in sideMenuSetting.links')
      link-side-menu.side-menu__links__link(
        :img='linkSetting.icon',
        :isActive='isActive(linkSetting)',
        @click='linkEvent(linkSetting)'
      ) {{ linkSetting.text }}
  .side-menu__separate
    .side-menu__separate__text.text-small
      slot(name='separateText')
  .side-menu__logout
    link-side-menu.side-menu__logout__link(@click='logoutEvent', img='manager/sidemenu/logout.svg')
      slot(name='logoutText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LinkSideMenu from '@/components/molecules/manager/LinkSideMenu.vue'
import { LinkSetting, SideMenuSetting, SideMenuSettings } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

@Component({
  components: {
    ImageBase,
    LinkSideMenu,
  },
})
export default class SideMenu extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // リンク押下時のイベント
  @Prop()
  linkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // 権限毎のサイドメニュー表示設定を取得
  private sideMenuSetting: SideMenuSetting =
    SideMenuSettings.findByRole(this.userRole) || SideMenuSettings.ADMIN_SETTING

  private isActive(linkSetting: LinkSetting): boolean {
    return linkSetting === this.currentLink
  }

  // ユーザ名
  private get userName() {
    return this.$bcbtCookies.authBcbt.get()?.currentApiUserName || ''
  }

  // 組織名
  private get organizationName() {
    switch (this.userRole) {
      case UserRoles.ACADEMY:
        return this.$bcbtCookies.authBcbt.get()?.currentApiAcademyName || ''
      case UserRoles.BRANCH:
        return this.$bcbtCookies.authBcbt.get()?.currentApiBranchName || ''
    }
    return ''
  }
}
</script>

<style lang="stylus" scoped>
.side-menu
  position relative
  width 262px
  height 100%
  padding 40px
  border-top-right-radius 40px
  background linear-gradient(
    93.75deg,
    var(--background) 84.9%,
    transparent 85.1%
  )

  &[data-role='admin']
    --background var(--color-manager-side-menu-admin__background)
  &[data-role='academy']
    --background var(--color-manager-side-menu-academy__background)
  &[data-role='branch']
    --background var(--color-manager-side-menu-branch__background)

  &__head
    padding-left 30px
    margin-bottom 10px

    &__logo
      margin-bottom 5px

    &__role
      color var(--color-manager-side-menu__text)

  &__links
    &__link
      margin-bottom 5px

  &__separate
    display flex
    align-items center
    justify-content center
    color var(--color-manager-side-menu__text)
    opacity 30%
    margin 10px 0

    &::before,
    &::after
      content ''
      width 50px
      margin 0 10px
      border-top 1px solid var(--color-manager-side-menu__text)
</style>
